import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// List of valid routes in the app (without .html)
const VALID_ROUTES = [
  "/",
  "/documents",
  "/consultation",
  "/about",
  "/contact",
  "/faq",
  "/account",
  "/auth",
  "/tools",
  "/blog",
  "/risk-management",
  "/welcome",
  "/tools/soa-generator",
  "/tools/risk-assessment",
  "/tools/gap-analysis",
  "/tools/internal-audit",
  "/tools/implementation-roadmap",
  "/tools/isms-scope-builder",
  "/tools/asset-inventory",
  "/tools/annex-a-selector",
  "/tools/supplier-risk-manager",
  "/tools/rto-rpo-bia-helper",
  "/privacy-policy",
  "/terms-of-service",
  "/disclaimer",
  "/refund-policy",
];

// Old paths that should redirect
const OLD_RISK_MANAGER_PATH = "/risk-manager";
const OLD_RISK_COPILOT_PATH = "/ISO27001Kit-RiskCopilot";
const RISK_REDIRECT_PATHS = [
  "/riskassessment",
  "/risk-assessment",
  "/risk-management-tool",
  "/iso-27001-risk-management",
];

export const HtmlRedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search } = location;
    
    // Remove trailing slash for comparison (except for root)
    const normalizedPath = pathname !== "/" && pathname.endsWith("/") 
      ? pathname.slice(0, -1) 
      : pathname;
    
    // Redirect old /risk-manager and related paths to /risk-management
    if (normalizedPath === OLD_RISK_MANAGER_PATH || RISK_REDIRECT_PATHS.includes(normalizedPath)) {
      navigate("/risk-management" + search, { replace: true });
      return;
    }
    
    // Redirect old /ISO27001Kit-RiskCopilot to /risk-copilot
    if (normalizedPath === OLD_RISK_COPILOT_PATH || normalizedPath.startsWith(OLD_RISK_COPILOT_PATH + "/")) {
      const subPath = normalizedPath.replace(OLD_RISK_COPILOT_PATH, "/risk-copilot");
      navigate(subPath + search, { replace: true });
      return;
    }
    
    // Redirect all /pdfs/ paths (old PDF URLs) to /documents
    if (normalizedPath.startsWith("/pdfs/") || normalizedPath === "/pdfs") {
      navigate("/documents" + search, { replace: true });
      return;
    }
    
    // Check if path ends with .html
    if (pathname.endsWith(".html")) {
      // Handle /index.html specifically - redirect to root
      if (pathname === "/index.html") {
        navigate("/" + search, { replace: true });
        return;
      }
      
      // Remove .html extension
      const cleanPath = pathname.slice(0, -5);
      
      // Check if the clean path exists in valid routes
      if (VALID_ROUTES.includes(cleanPath)) {
        navigate(cleanPath + search, { replace: true });
      }
    }
  }, [location, navigate]);

  return null;
};
